import type { GlobalProps } from '@emotion/react';
import { Global as EmotionGlobal } from '@emotion/react';
import type { ReactElement } from 'react';

export const Global = (props: GlobalProps): ReactElement => {
  return <EmotionGlobal {...props} />;
};
